import type { Ref } from 'vue'
import { markConversationRead, markConversationSeen, sendTypingIndicator } from '@/services/wootdashConversations'
import { markRailRead } from '@/composables/useRailConversations'

// "Visto" e "digitando…" no WhatsApp do contato, pela conversa aberta no painel.
// - seen(): ao abrir a conversa, ao chegar mensagem do contato com ela aberta e ao voltar pra aba. O backend só
//   manda um "visto" por mensagem, então chamar de novo é barato. É também o "o agente viu": zera o badge de
//   não lidas dele (na hora, no rail; e no servidor, que avisa as outras abas dele).
// - typing(): a cada tecla; sai no máximo a cada TYPING_EVERY_MS (a Meta mostra por até 25 s ou até a resposta
//   chegar). Depois de enviar, sent() zera o intervalo: a resposta apaga o "digitando" no celular do contato.
//   Nota interna nunca avisa nada.
export const TYPING_EVERY_MS = 20_000

export function useWhatsAppPresence(token: Ref<string>, now: () => number = Date.now) {
  let lastTypingAt = 0
  let lastTypingConv = ''

  function seen(conversationId: string | null | undefined) {
    if (!conversationId || !token.value) return
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return
    void markConversationSeen(token.value, conversationId)
    markRailRead(conversationId)
    void markConversationRead(token.value, conversationId)
  }

  function typing(conversationId: string | null | undefined, isPrivateNote: boolean) {
    if (!conversationId || !token.value || isPrivateNote) return
    const t = now()
    if (conversationId === lastTypingConv && t - lastTypingAt < TYPING_EVERY_MS) return
    lastTypingAt = t
    lastTypingConv = conversationId
    void sendTypingIndicator(token.value, conversationId)
  }

  function sent() {
    lastTypingAt = 0
  }

  return { seen, typing, sent }
}
